import { MutableRefObject } from 'react'

const EVENT_NAME = 'productGridResized'

type ResizedEventDetail = ResizeObserverEntry[]

export const useProductGridResized = () => {
  const publish = (ref: MutableRefObject<HTMLElement | null>) => {
    const observer = new ResizeObserver((entries) => {
      const event = new CustomEvent<ResizedEventDetail>(EVENT_NAME, {
        detail: entries,
      })
      document.dispatchEvent(event)
    })

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }

  const subscribe = (callback: (entries: ResizedEventDetail) => unknown) => {
    const handler: EventListener = (event) => {
      const { detail } = event as CustomEvent<ResizedEventDetail>
      callback(detail)
    }

    document.addEventListener(EVENT_NAME, handler)

    return () => {
      document.removeEventListener(EVENT_NAME, handler)
    }
  }

  return { publish, subscribe }
}
